<style lang="scss">
.customers-online-card-wrapper {
  .modal-dialog {
    max-width: 1200px;
  }

  .modal-content {
    overflow: hidden;
  }

  .modal-body {
    padding: 0;
    max-height: calc(100vh - 220px);
  }

  .table-wrapper {
    max-height: calc(100vh - 220px);
    overflow-y: auto;
  }
}

.customers-online-card-link {
  color: #2e478d;
}

.customers-online-card {
  &:hover {
    cursor: pointer;
    box-shadow: 0 6px 20px 2px rgba(0, 0, 0, 0.2);

    .customers-online-card-link {
      text-decoration: underline;
    }
  }
}
</style>

<template>
  <div class="customers-online-card-wrapper">
    <div class="card customers-online-card" @click="toggleShowModal">
      <div class="card-header">
        Mitglieder online
      </div>
      <div class="card-body">
        <strong class="customers-online-card-link"
          ><span :class="id" ref="customers-online">{{
            customersOnline
          }}</span></strong
        >
      </div>
    </div>
    <v-modal v-if="showModal" :show.sync="showModal">
      <h4 slot="header" class="title title-up">Mitglieder online</h4>
      <online-customer-table></online-customer-table>
    </v-modal>
  </div>
</template>

<script lang="babel">
import OnlineCustomerTable from "@/components/OnlineCustomerTable";
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    OnlineCustomerTable,
    'v-modal': Modal
  },
  data() {
    return {
      showModal: false,
      animation: null,
    };
  },
  props: {
    id: {
      required: true,
    }
  },
  computed: {
    customersOnline() {
      return this.$store.getters['online/onlines'].filter(online => online.c !== null && online.p === false).length;
    }
  },
  methods: {
    toggleShowModal() {
      this.showModal = !this.showModal;
    }
  },
  watch: {
    customersOnline() {
      if(this.customersOnline != undefined && this.customersOnline != null ) {
        this.$refs['customers-online'].innerHTML = "";
        [...this.customersOnline.toString()].forEach(
          c =>
            (this.$refs['customers-online'].innerHTML +=
              "<span class='letter'>" + c + "</span>")
        );
        this.animation = this.$anime({
          targets:  '.'+this.id + ' .letter',
          scale: [4, 1],
          opacity: [0, 1],
          translateZ: 0,
          easing: "easeOutExpo",
          duration: 950,
          delay: function(el, i) {
            return 70 * i;
          }
        });
      }
    }
  }
};
</script>
